const CORRELATION_HEADER = 'X-Correlation-Id';

export function createCorrelationId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    return `corr-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function getCorrelationIdFromResponse(response: Response): string | undefined {
    return response.headers.get(CORRELATION_HEADER) ?? undefined;
}

export function withCorrelationHeaders(
    headers?: HeadersInit,
    correlationId?: string
): Headers {
    const next = new Headers(headers);
    const id = correlationId ?? createCorrelationId();
    next.set(CORRELATION_HEADER, id);
    return next;
}
